export default "__VITE_ASSET__DlH2PPj1__"